/**
 * @fileoverview PUT handler for the "/internal_user_groups/anonymous_users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsAnonymousUsersCacheKeys } from "./constants";
import type {
  AppSettingsInternalUserGroupsAnonymousUsersProps,
  PutAppSettingsInternalUserGroupsAnonymousUsersResult,
} from "./types";

export const putAppSettingsInternalUserGroupsAnonymousUsers = reactQueryMutationAdapter(
  appSettingsInternalUserGroupsAnonymousUsersCacheKeys,
  ({
    appGroupId,
    appApiKey,
    ipAddress,
  }: AppSettingsInternalUserGroupsAnonymousUsersProps): Promise<PutAppSettingsInternalUserGroupsAnonymousUsersResult> => {
    const props = {
      app_group_id: appGroupId,
      app_api_key: appApiKey,
      ip_address: ipAddress,
    };

    return fetch(
      "/internal_user_groups/anonymous_users",
      "PUT",
      props,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
